import { HttpHeaders, HttpRequest } from '@angular/common/http';

export class HttpHeadersService {

  public hasNoModalHeader(req: HttpRequest<any>): boolean {
    return req.headers.has('no-error-modal');
  }

  public hasNoLogHeader(req: HttpRequest<any>): boolean {
    return req.headers.has('no-log');
  }

  public hasDisabledGlobalErrorHandler(req: HttpRequest<any>): boolean {
    return req.headers.has('disable-global-error-handler');
  }

  public addNoLogHeader(headers: HttpHeaders): HttpHeaders {
    return headers.set('no-log', 'yes');
  }

  public addNoModalHeader(headers: HttpHeaders): HttpHeaders {
    return headers.set('no-error-modal', 'yes');
  }

  public disableGlobalErrorHandler(headers: HttpHeaders): HttpHeaders {
    return headers.set('disable-global-error-handler', 'yes');
  }
}
